import { ThemeProvider } from "styled-components";
import { useMainContext } from "../contexts/main";
import { getMainTheme } from "../utils/theme";
import MasterHeader from "./MasterHeader";
import { MainBody } from "../styles/CommonStyles"
import Toast from "../components/common/Toast";
import {useWindowSize} from "../hooks/common/useWindowSize";
import {MOBILE_SIZE} from "../constants/common";
import BottomBar from "../components/common/BottomBar";
import {useEffect} from "react";

const MainLayout = ({ children }) => {

    const { main: { theme, lang } } = useMainContext()
    const { width } = useWindowSize()

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [])

    return (
        <ThemeProvider theme={getMainTheme(theme, lang)}>
            <MasterHeader  />
            <MainBody>
                {children}
            </MainBody>
            <Toast />
            {width < MOBILE_SIZE &&
                <BottomBar />
            }
        </ThemeProvider>
    )
}


export default MainLayout;